import React from 'react';
import {
  FormControlLabel,
  RadioGroup,
  Radio,
  Grid,
  Typography,
} from '@mui/material';
import {Label} from '@mui/icons-material';
import {IsNullOrEmptyOrUndefined} from '../../utils/helpers';

type ItemRadioOptionsProps = {
  key: string;
  value: string | number;
  caption?: string;
};

interface RadioGroupProps {
  values?: string | number;
  onChange?: (
    event: React.ChangeEvent<HTMLInputElement>,
    value: string | number
  ) => void;
  options?: Array<ItemRadioOptionsProps>;
  name?: string;
}

function RadioGroups({
  values,
  options,
  onChange,
  name,
  ...other
}: RadioGroupProps) {
  return (
    <RadioGroup value={values} onChange={onChange} row {...other} name={name}>
      {options?.map((item, index) => (
        <Grid paddingRight={4} key={'RadioGroup__' + index}>
          <FormControlLabel
            key={index}
            value={item.value}
            control={<Radio />}
            label={item.key}
          />
          {!IsNullOrEmptyOrUndefined(item?.caption) && (
            <Typography
              component="div"
              variant="caption"
              display="block"
              fontSize="11px"
              marginLeft="30px"
              marginTop="-4px"
              dangerouslySetInnerHTML={{__html: item.caption}}
            ></Typography>
          )}
        </Grid>
      ))}
    </RadioGroup>
  );
}
export default RadioGroups;
